<template>
  <div class="d-flex align-center">
    <TimeInput
      :value="selectedTime.from"
      :label="t('От', options)"
      class="w-100"
      @input="handleInputFrom"
      @blur="handleBlur"
    />
    <span class="text-h5 text--secondary mx-4">
      —
    </span>
    <TimeInput
      ref="timeInputToRef"
      :value="selectedTime.to"
      :label="t('До', options)"
      class="w-100"
      @input="handleInputTo"
      @blur="handleBlur"
    />
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, ref } from 'vue'
import I18NextVue from 'i18next'
import TimeInput from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/components/RangeTimeSelector/components/TimeInput.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

type Time = NonNullable<Extract<Filters['timeWork'], { type: 'custom' }>['time']>

const emit = defineEmits(['input'])

const props = withDefaults(defineProps<{
  value?: Time,
}>(), {
  value: () => ({ from: '00:00', to: '23:59' }),
})

const { t, language } = I18NextVue
const options = { ns: language }

const { value: selectedTime } = toRefs(props)

const timeInputToRef = ref()
const handleInputFrom = (timeFrom: string | null) => {
  emit('input', {
    from: timeFrom || '00:00',
    to: selectedTime.value.to,
  })

  if (!timeInputToRef.value || window.MOBILE_VERSION) {
    return
  }

  const [, oldMinutes] = `${selectedTime.value.from}`.split(':').map(Number)
  const [, newMinutes] = `${timeFrom}`.split(':').map(Number)

  if (oldMinutes === newMinutes) {
    return
  }

  if (/^\d{2}$/.test(String(newMinutes)) && newMinutes >= 0 && newMinutes <= 59) {
    timeInputToRef.value.$el.querySelector('input')?.focus()
  }
}

const handleInputTo = (timeTo: string | null) => {
  emit('input', {
    from: selectedTime.value.from,
    to: timeTo || '23:59',
  })
}

const handleBlur = async () => {
  const from = selectedTime.value.from > selectedTime.value.to ? selectedTime.value.to : selectedTime.value.from
  const to = selectedTime.value.to < selectedTime.value.from ? selectedTime.value.from : selectedTime.value.to

  // Хак: добавляем/удаляем секунды для принудительного обновления поля, если оно было очищено
  emit('input', { from: `${from}:00`, to: `${to}:00` })
  await nextTick()
  emit('input', { from, to })
}
</script>
